// SAT Module Zone Routes Component
import { BasePortal, MainLoading } from '@ice-web-app/shared-ui';
import { Suspense, lazy } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { routes, toRelativePath } from './routes';

// Lazy load pages
const SettingsPage = lazy(() => import('../pages/settings'));
const SchoolStructurePage = lazy(() => import('../pages/school-structure'));
const TeachersPage = lazy(() => import('../pages/user-management/teachers'));
const TeacherDetailPage = lazy(() => import('../pages/user-management/teacher-detail'));
const CurriculumPlanPage = lazy(() => import('../pages/curriculum-plan'));
const RulesPreferencesPage = lazy(() => import('../pages/rules-preferences'));
const LunchStructurePage = lazy(() => import('../pages/school-structure/lunch-structure'));
const TimetablePage = lazy(() => import('../pages/timetable'));
const CreateTimetablePage = lazy(() => import('../pages/timetable/create-timetable'));
const CreateTimetableVersionPage = lazy(() => import('../pages/timetable/version-create'));
const NotFound = lazy(() => import('../../portal/pages/not-found'));

export function ZoneRoutes() {
  return (
    <Routes>
      {/* Redirect base to settings */}
      <Route path={toRelativePath(routes.base)} element={<Navigate to={routes.settings} />} />

      {/* Main layout wrapper */}
      <Route
        element={<BasePortal sidebar microSystem showUserRole miniSidebar={true} navbar={true} sidebarHeader={true} />}
      >
        {/* 404 */}
        <Route
          path="*"
          element={
            <Suspense fallback={<MainLoading />}>
              <NotFound />
            </Suspense>
          }
        />

        {/* Settings */}
        <Route
          path={toRelativePath(routes.settings)}
          element={
            <Suspense fallback={<MainLoading />}>
              <SettingsPage />
            </Suspense>
          }
        />

        {/* Lunch Structure */}
        <Route
          path={toRelativePath(routes.lunchStructure)}
          element={
            <Suspense fallback={<MainLoading />}>
              <LunchStructurePage />
            </Suspense>
          }
        />

        {/* School Structure */}
        <Route
          path={toRelativePath(routes.schoolStructure)}
          element={
            <Suspense fallback={<MainLoading />}>
              <SchoolStructurePage />
            </Suspense>
          }
        />

        {/* Teacher Detail */}
        <Route
          path={toRelativePath(routes.teacherDetail(':teacherId'))}
          element={
            <Suspense fallback={<MainLoading />}>
              <TeacherDetailPage />
            </Suspense>
          }
        />

        {/* Teachers List */}
        <Route
          path={toRelativePath(routes.teachers)}
          element={
            <Suspense fallback={<MainLoading />}>
              <TeachersPage />
            </Suspense>
          }
        />

        {/* Curriculum Plan */}
        <Route
          path={toRelativePath(routes.curriculumPlan)}
          element={
            <Suspense fallback={<MainLoading />}>
              <CurriculumPlanPage />
            </Suspense>
          }
        />

        {/* Rules & Preferences */}
        <Route
          path={toRelativePath(routes.rulesPreferences)}
          element={
            <Suspense fallback={<MainLoading />}>
              <RulesPreferencesPage />
            </Suspense>
          }
        />

        {/* Create Timetable */}
        <Route
          path={toRelativePath(routes.createTimetable)}
          element={
            <Suspense fallback={<MainLoading />}>
              <CreateTimetablePage />
            </Suspense>
          }
        />

        {/* Create Timetable Version */}
        <Route
          path={toRelativePath(routes.createTimetableVersion)}
          element={
            <Suspense fallback={<MainLoading />}>
              <CreateTimetableVersionPage />
            </Suspense>
          }
        />

        {/* Timetable Views */}
        <Route
          path={toRelativePath(routes.timetable)}
          element={
            <Suspense fallback={<MainLoading />}>
              <TimetablePage />
            </Suspense>
          }
        />
      </Route>
    </Routes>
  );
}

export default ZoneRoutes;
